import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getImageCollection } from '../api/images';
import ImageTools from '../components/ImageTools';

const ImageToolsPage = () => {
  const [searchParams] = useSearchParams();
  const collectionId = searchParams.get('collection');
  const [collection, setCollection] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCollection = async () => {
      if (!collectionId) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const data = await getImageCollection(collectionId);
        setCollection(data);
      } catch (err) {
        console.error('Error fetching collection:', err);
        setError('Failed to load image collection. Please check if the collection ID is valid.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchCollection();
  }, [collectionId]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-ui-light-text-primary dark:text-ui-dark-text-primary mb-6">
        Astronomical Image Tools
      </h1>
      
      {loading && (
        <div className="flex justify-center my-4">
          <svg className="w-8 h-8 text-primary-600 dark:text-primary-400 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      )}
      
      {error && (
        <div className="mb-3 p-4 rounded-md bg-status-error-light-bg dark:bg-status-error-dark-bg text-status-error-light-text dark:text-status-error-dark-text">
          {error}
        </div>
      )}
      
      {collection && (
        <div className="p-4 mb-3 rounded-md shadow-md bg-ui-light-card dark:bg-ui-dark-card">
          <h2 className="text-xl font-bold text-ui-light-text-primary dark:text-ui-dark-text-primary">
            {collection.name}
          </h2>
          <p className="mt-2 text-base text-ui-light-text-secondary dark:text-ui-dark-text-secondary">
            {collection.description || 'No description provided'}
          </p>
          <p className="mt-1 text-sm text-ui-light-text-muted dark:text-ui-dark-text-muted">
            Path: {collection.path}
          </p>
        </div>
      )}
      
      {/* Render the Image Tools component */}
      <div>
        <ImageTools collectionId={collectionId} />
      </div>
    </div>
  );
};

export default ImageToolsPage;